import * as Sentry from "@sentry/nextjs";

export const captureError = (error: Error) => {
  console.error(error.message);
  Sentry.captureException(error);
  return Sentry.close();
};
